var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"safeplan-list"},[_vm._v("세이프플랜 "+_vm._s(_vm.safeplan)+"기 리스트")])}
var staticRenderFns = []

export { render, staticRenderFns }